import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { InformationsAnzeigeTestIds } from './sb-informations-anzeige.test-ids';

@Component({
  selector: 'app-sb-informations-anzeige',
  imports: [MatIcon],
  templateUrl: './sb-informations-anzeige.component.html',
  styleUrl: './sb-informations-anzeige.component.scss'
})
/**
 * Hier werden keine Afos umgesetzt, Begründung:
 * Diese Klasse wird zu reinen Design-Anzeige-Zwecken verwendet.
 * Diese Komponente wird zur Anzeige von Informationen verwendet wie
 * Membership-Änderungen oder das Löschen von Nachrichten.
 */
export class SbInformationsAnzeigeComponent {
  protected readonly testIds = InformationsAnzeigeTestIds;
  public text = input<string>();
}
